import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import JoditEditor from 'jodit-react';
import 'react-toastify/dist/ReactToastify.css';

const EditPrivacyPolicy = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        policy: '',
        status: false,
    });
    const [isFetching, setIsFetching] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchPolicy = async () => {
            try {
                const res = await axios.get(`https://api.sofiasurgicals.com/api/get-PrivacyPolicy-by-id/${id}`);
                setFormData({
                    policy: res.data.policy || '',
                    status: !!res.data.status,
                });
            } catch (err) {
                console.error(err);
                toast.error('Failed to fetch Privacy Policy details.');
            } finally {
                setIsFetching(false);
            }
        };

        fetchPolicy();
    }, [id]);

    const handlePolicyChange = (policy) => {
        setFormData((prev) => ({ ...prev, policy }));
    };

    const handleStatusChange = (e) => {
        setFormData((prev) => ({ ...prev, status: e.target.checked }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await axios.put(`https://api.sofiasurgicals.com/api/update-PrivacyPolicy/${id}`, formData, {
                headers: { 'Content-Type': 'application/json' },
            });
            toast.success('Privacy Policy updated successfully!');
            navigate('/all-PrivacyPolicy');
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Failed to update Privacy Policy.');
        } finally {
            setIsLoading(false);
        }
    };

    if (isFetching) {
        return <p className="text-center mt-4">Loading Privacy Policy...</p>;
    }

    return (
        <>
            <ToastContainer />
            <div className="bread d-flex justify-between items-center mb-4">
                <h4>Edit Privacy Policy</h4>
            </div>

            <form className="row g-3" onSubmit={handleSubmit}>
                <div className="col-md-12">
                    <label className="form-label">Privacy Policy Content</label>
                    <JoditEditor
                        value={formData.policy}
                        onChange={handlePolicyChange}
                        config={{ readonly: false }}
                    />
                </div>

                <div className="col-md-6 form-check">
                    <input
                        type="checkbox"
                        name="status"
                        className="form-check-input"
                        checked={formData.status}
                        onChange={handleStatusChange}
                        id="statusCheckbox"
                    />
                    <label className="form-check-label" htmlFor="statusCheckbox">
                        Active
                    </label>
                </div>

                <div className="col-12 text-center">
                    <button
                        type="submit"
                        className={`btn btn-primary ${isLoading ? 'disabled' : ''}`}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Please Wait...' : 'Update Privacy Policy'}
                    </button>
                </div>
            </form>
        </>
    );
};

export default EditPrivacyPolicy;